<template>
  <div class="form formLine">
    <el-form :model="formInfo.data"
             :inline="formInfo.inline"
             :rules="formInfo.rules"
             ref="form"
             :label-width="formInfo.labelWidth"
             style="text-align:left">
      <el-form-item v-for="item of formInfo.list"
                    v-show="item.shows?item.show:true"
                    :key="item.label"
                    :label="item.label"
                    :prop="item.value"
                    :label-width="item.labelWidth?item.labelWidth:''"
                    :class="item.className">
        <template slot="label">
          <span style="position:relative">
              <span>{{item.label}}</span>
              <el-tooltip style="position:absolute;right:-8px;" class="item" effect="dark" placement="top" v-if="item.labelContent">
                <div slot="content">
                  <p>{{item.labelContent}}</p>
                </div>
                <i class="el-icon-info table-msg" />
            </el-tooltip>
          </span>
        </template>
        <el-input v-if="item.type=='text'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder?item.placeholder:('请输入'+item.label.slice(0,item.label.length-1))"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @input="item.input?hanClick(item.input):null"
                  @keyup.enter.native="hanClick('sub')"
                  @change="selectChange">
            <i slot="suffix" v-if="item.append" class="el-input__icon el-icon-copy-document" @click="appendClick(item.value)"></i>
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
        </el-input>
        <!-- textSH税号 -->
        <el-input v-if="item.type=='textSH'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder?item.placeholder:('请输入'+item.label.slice(0,item.label.length-1))"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @input="item.input?hanClick(item.input):null"
                  @keyup.enter.native="hanClick('sub')"
                  @change="selectChange">
            <i slot="suffix" v-if="item.append" class="el-input__icon el-icon-copy-document" @click="appendClick(item.value)"></i>
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
        </el-input>
         <el-input v-if="item.type=='float'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @input="item.input?hanClick(item.input):null"
                  @keyup.enter.native="hanClick('sub')">
            <template slot="append" v-if="item.append">{{item.append}}</template>
        </el-input>
         <el-input v-if="item.type=='floatNum'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\-\d.]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @input="item.input?hanClick(item.input):null"
                  @keyup.enter.native="hanClick('sub')">
            <template slot="append" v-if="item.append">{{item.append}}</template>
        </el-input>
         <el-input v-if="item.type=='floatTwo'"
                  :value="formatAmount(Number(formInfo.data[item.value]))"
                  type="text"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly">
            <template slot="append" v-if="item.append">{{item.append}}</template>
        </el-input>
        <el-input v-if="item.type=='number'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder?item.placeholder:('请输入'+item.label.slice(0,item.label.length-1))"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @input="item.input?hanClick(item.input):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-input v-if="item.type=='numberPhone'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\-\d]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @input="item.input?hanClick(item.input):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-input v-if="item.type=='btnText'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-button type="primary" v-if="item.type=='btnText'" size="small" @click="btnClick('one')">读取</el-button>
        <el-input v-if="item.type=='btnText2'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-button type="primary" v-if="item.type=='btnText2'" size="small" @click="btnClick('two')">读取</el-button>
        <el-input v-if="item.type=='btnText3'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-button type="primary" v-if="item.type=='btnText3'" size="small" @click="btnClick('three')">读取</el-button>
        <el-input v-if="item.type=='numberT'"
                  v-model="formInfo.data[item.value]"
                  type="number"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-input v-if="item.type=='textNum'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @keyup.enter.native="hanClick('sub')"
                  @change="selectChange">
          <template slot="prepend">{{tPrefixion}}</template>
        </el-input>
        <div v-else-if="item.type == 'textThree'">
          <el-input v-model="formInfo.data[item.value1]"
                    type="text"
                    :disabled="item.disabled"
                    placeholder="长"
                    style="width:90px"
                    size="small"
                    :clearable="item.unclearable?false:true"
                    @blur="item.blur?hanClick(item.blur):null">
          </el-input>-
          <el-input v-model="formInfo.data[item.value2]"
                    type="text"
                    :disabled="item.disabled"
                    placeholder="宽"
                    style="width:90px"
                    size="small"
                    :clearable="item.unclearable?false:true"
                    @blur="item.blur?hanClick(item.blur):null">
          </el-input>-
          <el-input v-model="formInfo.data[item.value3]"
                    type="text"
                    :disabled="item.disabled"
                    placeholder="高"
                    style="width:90px"
                    size="small"
                    :clearable="item.unclearable?false:true"
                    @blur="item.blur?hanClick(item.blur):null">
          </el-input>
        </div>
        <el-input v-if="item.type=='textarea'"
                  v-model="formInfo.data[item.value]"
                  type="textarea"
                  autosize
                  :rows="item.rows?item.rows:2"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-input v-else-if="item.type=='password'"
                  v-model="formInfo.data[item.value]"
                  type="password"
                  :disabled="item.disabled"
                  @blur="item.blur?hanClick(item.blur):null"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-select v-else-if="item.type=='select客户区域：'"
                   v-model="formInfo.data[item.value]"
                   :placeholder="'请选择'"
                   size="small"
                   :clearable="item.unclearable?false:true"
                   :style="item.selectStyle">
          <el-option :key="formInfo.data[item.value]"
                     :label="formInfo.data[item.label]"
                     :value="formInfo.data[item.value]"
                     style="height: auto;padding:0">
            <el-tree :data="listTypeInfo[item.list]"
                      :props="item.defaultProps"
                      node-key="id"
                      accordion
                      highlight-current
                      @node-click="handleNodeClick"
                      :style="item.style"
                      >
            </el-tree>
          </el-option>
        </el-select>
        <el-autocomplete class="inline-input"
                         v-else-if="item.type=='autocomplete'"
                         v-model="formInfo.data[item.value]"
                         :fetch-suggestions="querySearch"
                         @input="hanClick('autoinput')"
                         :placeholder="'请输入' + item.label.slice(0,item.label.length-1)"
                         @select="handleSelect"></el-autocomplete>
        <el-select v-else-if="item.type=='select'+item.label"
                   v-model="formInfo.data[item.value]"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   filterable
                   size="small"
                   :remote="item.remote"
                   v-show="item.flag != undefined?item.flag:true"
                   :remote-method="item.remote?remoteMethod:none"
                   @focus="item.remote?focus(item.value):''"
                   @change="selectChange($event,item.label)"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="item.placeholder?item.placeholder:'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="item.blur?hanClick(item.blur):null">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
                     :disabled="item.disabled">
          </el-option>
        </el-select>
        <el-select v-else-if="item.type=='selectCreate'+item.label"
                   v-model="formInfo.data[item.value]"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   allow-create
                   filterable
                   size="small"
                   :remote="item.remote"
                   v-show="item.flag != undefined?item.flag:true"
                   :remote-method="item.remote?remoteMethod:none"
                   @focus="item.remote?focus(item.value):''"
                   @change="selectChange($event,item.label)"
                   @blur="blurChange($event,item.label)"
                   @input="inputChange($event,item.label)"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="item.placeholder?item.placeholder:'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="hanClick('sub')">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="item.type=='selectRemote'+item.label"
                   v-model="formInfo.data[item.value]"
                   v-show="item.flag != null?item.flag:true"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   filterable
                   size="small"
                   :remote="item.remote"
                   :remote-method="item.remote?remoteMethodTwo:none"
                   @focus="item.remote?focus(item.value,formInfo.data[item.value]):''"
                   @change="selectChange($event,item.label)"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="item.placeholder?item.placeholder:'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="hanClick('sub')">
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="item.type=='selectMany'+item.label"
                   v-model="formInfo.data[item.value]"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   multiple
                   filterable
                   size="small"
                   :remote="item.remote"
                   :remote-method="item.remote?remoteMethod:none"
                   @focus="item.remote?focus(item.value):''"
                   @change="selectChange($event,item.label)"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="hanClick('sub')">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
                     :disabled="item.disabled">
          </el-option>
        </el-select>
        <el-radio-group v-model="formInfo.data[item.value]" :disabled="item.disabled" v-else-if="item.type=='selectRadio'" @input="selectRadioInput(formInfo.data[item.value],'selectRadio',item.label)">
          <el-radio v-for="item in listTypeInfo[item.list]" :key="item.value" :label="item.value">{{item.label}}</el-radio>
        </el-radio-group>
        <el-checkbox v-model="formInfo.data[item.value]" :disabled="item.disabled" v-else-if="item.type=='checked'" @change="checkedChange2(formInfo.data[item.value],'selectChecked',item.label)">{{item.checkedName}}</el-checkbox>
        <el-date-picker v-else-if="item.type=='date'"
                        v-model="formInfo.data[item.value]"
                        size="small"
                        type="datetime"
                        :disabled="item.disabled"
                        :style="item.style"
                        :clearable="item.unclearable?false:true"
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="dataChange"
                        @keyup.enter.native="hanClick('sub')">
        </el-date-picker>
        <el-date-picker v-else-if="item.type=='dateDay'"
                        v-model="formInfo.data[item.value]"
                        size="small"
                        type="date"
                        :disabled="item.disabled"
                        :style="item.style"
                        :clearable="item.unclearable?false:true"
                        :editable="item.editable?false:true"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        @change="changeDate(item.value)"
                        @keyup.enter.native="hanClick('sub')">
        </el-date-picker>
        <el-date-picker v-else-if="item.type=='dateTime'"
                        v-model="formInfo.data[item.value]"
                        size="small"
                        type="datetime"
                        :disabled="item.disabled"
                        :style="item.style"
                        :clearable="item.unclearable?false:true"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="changeDate"
                        @keyup.enter.native="hanClick('sub')">
        </el-date-picker>
        <el-time-select v-else-if="item.type=='Time'"
                        v-model="formInfo.data[item.value]"
                        size="small"
                        :clearable="item.unclearable?false:true"
                        :disabled="item.disabled"
                  :picker-options="{
                    start: '06:00',
                    step: '01:00',
                    end: '22:00'
                  }"
                  placeholder="选择时间"
                  @keyup.enter.native="hanClick('sub')">
                </el-time-select>
        <el-date-picker v-else-if="item.type=='dateDayTwo'"
                        v-model="formInfo.data[item.value]"
                        size="small"
                        type="date"
                        :disabled="item.disabled"
                        :style="item.style"
                        :clearable="item.unclearable?false:true"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptionsDayTwo"
                        @change="changeDate"
                        @keyup.enter.native="hanClick('sub')">
        </el-date-picker>
        <div v-else-if="item.type == 'slot'">
            <slot :name="'col-' + item.value" :value="item.value" />
        </div>
        <div v-else-if="item.type == 'period'">
          <el-date-picker v-model="formInfo.data[item.value1]"
                          style="width:280px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="开始时间"
                          :clearable="true">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'month'">
          <el-date-picker v-model="formInfo.data[item.value]"
                          :style="item.style"
                          size="small"
                          type="month"
                          value-format="yyyy-MM"
                          placeholder="开始年月"
                          :clearable="item.unclearable?false:true">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'year'">
          <el-date-picker v-model="formInfo.data[item.value]"
                          :style="item.style"
                          size="small"
                          type="year"
                          value-format="yyyy"
                          placeholder="开始年"
                          :clearable="true">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'period1'">
          <el-date-picker
            v-model="formInfo.data[item.value]"
            style="width:280px"
            size="small"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :disabled='item.disabled'
            :clearable="true">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'period2'">
          <el-date-picker v-model="formInfo.data[item.value1]"
                          style="width:160px"
                          size="small"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled='item.disabled'
                          placeholder="开始日期"
                          @change="hanClick('changeDate', item.value1)">
          </el-date-picker>
          -
          <el-date-picker v-model="formInfo.data[item.value2]"
                          style="width:160px"
                          size="small"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled='item.disabled'
                          placeholder="结束日期"
                          @change="hanClick('changeDate', item.value2)">
          </el-date-picker>
        </div>
        <!-- 新增：日期区间 + 天数联动控件 -->
        <div v-else-if="item.type == 'periodDays'">
          <el-date-picker v-model="formInfo.data[item.value1]"
                          style="width:160px"
                          size="small"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled='item.disabled'
                          placeholder="开始日期"
                          @change="onPeriodDaysDateChange(item, 'start')">
          </el-date-picker>
          -
          <el-date-picker v-model="formInfo.data[item.value2]"
                          style="width:160px"
                          size="small"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled='item.disabled'
                          placeholder="结束日期"
                          @change="onPeriodDaysDateChange(item, 'end')">
          </el-date-picker>
          <el-input style="width:120px;margin-left:8px" size="small"
                    v-model="formInfo.data[item.valueDays]"
                    :disabled='item.disabled'
                    placeholder="天数"
                    @input="onPeriodDaysDaysInput(item, $event)">
            <template slot="append">天</template>
          </el-input>
        </div>
        <div v-else-if="item.type == 'period3'"> <!-- 产品报价单发货起始日期专用 -->
          <el-date-picker v-model="formInfo.data[item.value1]"
                          style="width:160px"
                          size="small"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled='item.disabled'
                          placeholder="开始日期">
          </el-date-picker>
          -
          <el-date-picker v-model="formInfo.data[item.value2]"
                          style="width:160px"
                          size="small"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled='item.disabled'
                          :picker-options="contractPickerOptions"
                          placeholder="结束日期">
          </el-date-picker>
        </div>
        <el-switch v-else-if="item.type=='switch'"
                   v-model="formInfo.data[item.value]"
                   :active-text="item.text1"
                   :inactive-text="item.text2"
                   :active-value="item.value1"
                   :inactive-value="item.value2">
        </el-switch>
        <BoyoUpload v-else-if="item.type=='upload'"
                    :action="action"
                    :src="formInfo.data[item.value]?addPrefixAndJoin(formInfo.data[item.value]):null"
                    :value="item.value"
                    :disabled="item.disabled"
                    @on-success="handleAvatarSuccess"
                    @on-removeImg="handleRemove"
                    @handlePictureCardPreview="handlePictureCardPreview">
        </BoyoUpload>
        <BoyoUpload v-else-if="item.type=='uploads'"
                    :action="action"
                    :src="formInfo.data[item.value]?addPrefixAndJoin(formInfo.data[item.value]):null"
                    :value="item.value"
                    :disabled="item.disabled"
                    @on-success="handleAvatarSuccess"
                    @on-removeImg="handleRemove"
                    @handlePictureCardPreview="handlePictureCardPreview">
        </BoyoUpload>
        <!-- <BoyoUploadtwo v-else-if="item.type=='uploads'"
                       :action="action"
                       :src="formInfo.data[item.value]?(imgUrl+formInfo.data[item.value]):null"
                       :value="item.value"
                       :disabled="item.disabled"
                       @on-success="handleAvatarSuccess">
        </BoyoUploadtwo> -->
        <BoyoUploadThree v-else-if="item.type=='uploadThree'"
                       :action="actionFile"
                       :src="formInfo.data[item.value]?(imgUrl+formInfo.data[item.value]):null"
                       :value="item.value"
                       :disabled="item.disabled"
                       :fileListHt="item.fileListHt"
                       @on-remove="handleAvatarRemove"
                       @on-success="handleAvatarSuccess">
        </BoyoUploadThree>
        <BoyoUploadtwo v-else-if="item.type=='uploadTwo'"
                       :action="action"
                       :src="formInfo.data[item.value]?(formInfo.data[item.value]):null"
                       :value="item.value"
                       :disabled="item.disabled"
                       :fileListHt="item.fileListHt"
                       @on-success="handleAvatarSuccess"
                       @on-remove="handleAvatarRemove"
                       @on-dialog="handleAvatarDialog">
        </BoyoUploadtwo>
        <div class="bgTextPar"
             v-else-if="item.type=='bgText'" :style="item.style">
          <div style="padding:7px;border:1px solid #000">
            <p class="bgText">{{formInfo.data[item.value]}} <span style="margin-left:30px;font-size:68px">{{item.unitName}}</span></p>
          </div>
          <!-- <div class="bgText bgDes">{{item.unitName}}</div> -->
          <div class="bgTextButton"
               @click="hanClick('formWeightSave')">保存</div>
          <div v-if="item.peoName">
            <p class="bgTextPeo">{{item.peoName}}</p>
          </div>
        </div>
        <!-- <div v-else-if="item.type=='bgText'">
          <el-button @click="hanClick('wageclick')">工资基础</el-button>
        </div> -->
        <!-- <div v-else-if="item.type=='xuanze'">
          <input type="text"
                 class="carno">
          <div class="jianc"
               @click="open">省份简称</div>
        </div> -->
        <div v-else-if="item.type=='showDes'"
             v-show="formInfo.showDes"
             class="showDes">
          <div class="showDesMargin">
            商品信息:
          </div>
          <div>
            <div v-show="formInfo.desDate.goodsSpec">规格1：{{formInfo.desDate.goodsSpec}}</div>
            <div v-show="formInfo.desDate.goodsSpec2">规格2：{{formInfo.desDate.goodsSpec2}}</div>
            <div v-show="formInfo.desDate.model1">型号1：{{formInfo.desDate.model1}}</div>
            <div v-show="formInfo.desDate.model2">型号2：{{formInfo.desDate.model2}}</div>
          </div>
        </div>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import config from '@/api/config'
import BoyoUpload from '@/components/BoyoUpload'
import BoyoUploadtwo from '@/components/BoyoUploadtwo'
import BoyoUploadThree from '@/components/BoyoUploadThree'

export default {
  name: 'BoyoForm',
  components: {
    BoyoUpload,
    BoyoUploadtwo,BoyoUploadThree
  },
  props: {
    formInfo: Object,
    refObj: Object,
    listTypeInfo: Object
  },
  data () {
    return {
      imgUrl: config.pingImgUrl,
      event: '', // 配合select的远程搜索事件
      action: config.upload,
      actionFile: config.uploadFile,
      tPrefixion:localStorage.tPrefixion?localStorage.tPrefixion:'',
      contractPickerOptions: {
        shortcuts: [{
          text: '7天后',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '15天后',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 15);
            picker.$emit('pick', date);
          }
        }, {
          text: '30天后',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          }
        }]
      },
      pickerOptionsDayTwo:{
        disabledDate:(time)=>{
          return time.getTime()<Date.now()-1*24*60*60*1000
        }
      },
    }
  },
  watch: {
    'formInfo.data': {
      deep: true,
      handler () {
        this.$emit('update:refObj', this.$refs.form)
        // 外部回显或编程式赋值后，同步 periodDays 的天数/结束日期
        this.$nextTick(() => this.syncAllPeriodDays())
      }
    }
  },
  mounted () {
    this.action = config.upload
    this.actionFile = config.uploadFile
    // 将form实例返回到父级
    this.$emit('update:refObj', this.$refs.form)
    // 初次挂载处理一次回显
    this.$nextTick(() => this.syncAllPeriodDays())
  },
  methods: {
    formatAmount(cellValue) {
      if (cellValue && typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(3))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 选择上传事件
    // handlePictureCardPreview (file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    // handleDownload (file) {
    //   console.log(file);
    // },
    // beforeAvatarUpload (file) {
    //   const isLt2M = file.size / 1024 / 1024 < 10;
    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 10MB!');
    //   }
    //   return isLt2M;
    // },
    gettoken(){
      let Token = localStorage.token;
      return { Token: JSON.parse(Token).value }
    },
    // 选择输入框选择事件
    handleSelect (item) {
      this.$emit('handleSelect', item)
    },
    // 选择输入框输入事件
    querySearch (queryString, cb) {
      this.$emit('querySearch', queryString, cb)
    },
    hanClick (event) {
      this.$emit('hanClick', event)
    },
    focus (val,query) {
      this.event = val
      this.$emit('formremoteFocus', this.event, query, 'remoteMethod')
    },
    remoteMethod (query) {
      // console.log(query)
      // if (query) {
        this.$emit('formremoteMethod', this.event, query, 'remoteMethod')
      // }
    },
    handleNodeClick (node) {
      this.$emit('handleNodeClick', node)
    },
    remoteMethodTwo (query) {
      // console.log(query)
      this.$emit('formremoteMethod', this.event, query, 'remoteMethod')
    },
    selectRadioInput (query,event,label) {
      // console.log(query)
      this.$emit('formremoteMethod',event, query, 'selectRadio' + label)
    },
    checkedChange2 (query,event,label) {
      // console.log(query)
      this.$emit('formremoteMethod',event, query, 'selectChecked' + label)
    },
    none () {

    },
    selectHeaderClick(label){
      this.$emit('selectHeaderClick', label)
    },
    selectChange (val, label) {
      this.$emit('formremoteMethod', this.event, val, 'select' + label)
      this.$emit('selectChange', this.event2, val, 'text')
    },
    btnClick(val) {
      this.$emit('btnClick',  val)
      // this.$emit('selectChange', this.event2, val, 'text')
    },
    appendClick (val) {
      this.$emit('appendClick', val)
    },
    blurChange (val, label) {
      this.$emit('formremoteMethod', this.event, val, 'blur' + label)
      // this.$emit('selectChange', this.event2, val, 'text')
    },
    inputChange (val, label) {
      this.$emit('formremoteMethod', this.event, val, 'input' + label)
      // this.$emit('selectChange', this.event2, val, 'text')
    },
    clear (val, label) {
      this.$emit('clear', this.event2, val, 'select')
    },
    changeDate (name) { // 日期选择发生变化事件
      this.$emit('changeDate',name)
    },
    // periodDays：日期变化联动天数字段
    onPeriodDaysDateChange(item, which) {
      // 触发父级计算，让父页面自行决定如何联动
      // 约定：向父级发送事件 'periodDays-change'，并携带字段配置
      this.$emit('formremoteMethod', which, item, 'periodDays-change')
      // 同时沿用原有 changeDate 事件，保持兼容
      if (which === 'start') {
        this.$emit('changeDate', item.value1)
      } else if (which === 'end') {
        this.$emit('changeDate', item.value2)
      }
      // 本地直接联动（提升交互即时性）
      const start = this.formInfo.data[item.value1]
      const end = this.formInfo.data[item.value2]
      
      // 如果开始日期或结束日期被清空，清空天数字段
      if (!start || !end) {
        this.$set(this.formInfo.data, item.valueDays, '')
        return
      }
      
      // 两个日期都存在时，计算天数
      if (start && end) {
        const s = new Date(start)
        const e = new Date(end)
        if (!isNaN(s.getTime()) && !isNaN(e.getTime())) {
          const diff = Math.ceil((e.getTime() - s.getTime()) / (1000*3600*24)) + 1
          this.$set(this.formInfo.data, item.valueDays, diff > 0 ? diff : '')
        }
      }
    },
    // periodDays：手动输入天数联动结束日期
    onPeriodDaysDaysInput(item, value) {
      // 限制只能输入数字，但允许空值
      if (value && !/^\d*$/.test(value)) {
        // 如果不是纯数字，则过滤掉非数字字符
        const filteredValue = value.replace(/[^\d]/g, '')
        this.$set(this.formInfo.data, item.valueDays, filteredValue)
        return
      }
      
      this.$emit('formremoteMethod', this.formInfo.data[item.valueDays], item, 'periodDays-days')
      // 同步到父级以便统一处理
      this.$emit('changeDate', item.valueDays)
      
      // 本地直接联动结束日期
      const start = this.formInfo.data[item.value1]
      const days = Number(this.formInfo.data[item.valueDays])
      
      // 如果天数为空或0，清空结束日期
      if (!this.formInfo.data[item.valueDays] || days <= 0) {
        this.$set(this.formInfo.data, item.value2, '')
        return
      }
      
      // 有开始日期和有效天数时，计算结束日期
      if (start && days > 0) {
        const d = new Date(start)
        d.setDate(d.getDate() + (days - 1))
        const y = d.getFullYear()
        const m = (d.getMonth()+1).toString().padStart(2,'0')
        const day = d.getDate().toString().padStart(2,'0')
        this.$set(this.formInfo.data, item.value2, `${y}-${m}-${day}`)
      }
    },
    dataChange (val) {
      this.$emit('dataChange', this.event, val, 'data')
    },

    handleAvatarSuccess (res, file, fileList, value) {
      this.$emit('on-success', res, file, fileList, value)
    },
    handleAvatarRemove (file, fileList, value) {
      this.$emit('on-remove', file, fileList, value)
    },
    handleAvatarDialog ( value) {
      this.$emit('on-dialog', value)
    },
    handlePictureCardPreview (url, value) {
      this.$emit('handlePictureCardPreview', url, value)
    },
    handleRemove (value) {
      if(value){
        this.formInfo.data[value] = ''
      }
    },
    addPrefixAndJoin(str) {
        // 分割字符串
        const parts = str.split(',');
        // 遍历数组，检查并修改每个元素
        const processedParts = parts.map(part => {
            // 检查是否包含前缀，如果不包含则添加
            if (!part.startsWith(this.imgUrl)) {
                return this.imgUrl + part;
            }
            return part;
        });
        // 重新拼接字符串
        return processedParts.join(',');
    },
    // 扫描所有 periodDays 项，在回显/外部赋值时把天数或结束日期补齐
    syncAllPeriodDays() {
      try {
        if (!this.formInfo || !Array.isArray(this.formInfo.list)) return
        for (const it of this.formInfo.list) {
          if (it && it.type === 'periodDays') {
            const start = this.formInfo.data[it.value1]
            const end = this.formInfo.data[it.value2]
            const daysVal = this.formInfo.data[it.valueDays]
            const days = Number(daysVal)
            // 有起止且无天数 → 计算天数
            if (start && end && (!days || days <= 0)) {
              const s = new Date(start)
              const e = new Date(end)
              if (!isNaN(s.getTime()) && !isNaN(e.getTime())) {
                const diff = Math.ceil((e.getTime() - s.getTime()) / (1000*3600*24)) + 1
                this.$set(this.formInfo.data, it.valueDays, diff > 0 ? diff : '')
              }
            }
            // 有开始和天数但无结束 → 反算结束日期
            if (start && days && days > 0 && !end) {
              const d = new Date(start)
              d.setDate(d.getDate() + (days - 1))
              const y = d.getFullYear()
              const m = (d.getMonth()+1).toString().padStart(2,'0')
              const day = d.getDate().toString().padStart(2,'0')
              this.$set(this.formInfo.data, it.value2, `${y}-${m}-${day}`)
            }
          }
        }
      } catch (e) {
        // 忽略回显期可能的空数据异常
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.form >>>.el-loading-spinner
  padding-right 2px
  box-sizing border-box
  text-align right
  .circular
    height 25px
    width 25px

/* 修复：el-form 校验错误提示层可能覆盖 input 右侧 clear 图标，导致无法点击 */
.form >>> .el-form-item__error
  pointer-events none
.form >>> .el-input__suffix
  z-index 2
  pointer-events auto
.form_item_one
  width 100%
  margin-right 0
  text-align left
.form_item_one>>> .el-form-item__content
  width 86.5%
.form_item_two
  width 50%
  margin-right 0
  text-align left
.form_item_two>>> .el-form-item__content
  width 75%
.form_item_twos
  width 50%
  margin-right 0
  text-align left
.form_item_twos>>> .el-form-item__content
  width 63%
.form_item_twoD
  width 75%
  margin-right 0
  text-align left
.form_item_twoD>>> .el-form-item__content
  width 85%
.form_item_three
  width 32%
  margin-right 0
  text-align left
.form_item_three>>> .el-form-item__content
  width 65%
.form_item_four
  width 25%
  margin-right 0
  text-align left
.form_item_four>>> .el-form-item__content
  width 65%
.bgTextPar
  display flex
  flex-direction row
.bgText
  color red
  width 460px
  height 85px
  line-height 85px
  background-color #000
  color #0af112
  font-size 72px
  text-align center
.xuanzePar
  display flex
  flex-direction row
.bgDes
  width 70px
  padding-right 20px
.gzButton
  border 1px solid #000
  margin-left 20px
  height 30px
  width 70px
  line-height 30px
  text-align center
  background-color #eee
.bgTextButton
  margin-left 20px
  background-color #409EFF
  height 50px
  margin-top 25px
  width 70px
  color #ffffff
  text-align center
  line-height 50px
  border-radius 5px
  cursor pointer
.showDes
  display flex
  flex-direction row
.showDesMargin
  margin-right 20px
.carno
  height 28px
  width 70%
  // border-radius 2px
.jianc
  // margin-left 80%
  float right
  background-color #409EFF
  height 40px
  margin-right 10%
  width 70px
  color #ffffff
  text-align center
  line-height 40px
  cursor pointer
.select_header
  color #606266
  font-size 18px
  margin-top 10px
</style>



// WEBPACK FOOTER //
// src/components/BoyoFormtwo/index.vue